import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useVerifyEmailMutation } from '../store/trialApi';

export function useTrialEmailVerification(token: string | null) {
  const { loginWithCustomToken } = useAuth();
  const [verifyEmail] = useVerifyEmailMutation();
  const [state, setState] = useState<'idle' | 'verifying' | 'awaiting-session' | 'error'>('idle');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) return;
    setState('verifying');
    verifyEmail({ token })
      .unwrap()
      .then(async (res) => {
        // Email is verified, but the backend couldn't mint a sign-in token — send the
        // user to a normal login rather than calling signInWithCustomToken(null).
        if (!res.customToken) {
          setError('Your email is verified. Please sign in to continue.');
          setState('error');
          return;
        }
        const result = await loginWithCustomToken(res.customToken);
        if (result.success) {
          // Don't navigate here — AuthContext's onAuthStateChanged listener hasn't
          // picked up the new session yet, so PrivateRoute would still see "signed
          // out" and bounce to /login. The caller redirects once isAuthenticated flips.
          setState('awaiting-session');
        } else {
          setError(result.error || 'Sign in failed. Please try again.');
          setState('error');
        }
      })
      .catch((err) => {
        const msg = (err as { data?: { message?: string } })?.data?.message;
        setError(msg || 'Verification failed. The link may have expired.');
        setState('error');
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return { state, error };
}
